import { css } from 'emotion';
import themeConfig from '@lyearn-team/theme-config';

export const main = css`
  display: flex;
  flex-direction: column;
  flex: 4;
  position: relative;
`;

export const mainBlock = css`
  background-color: #fff;
`;

export const sideView = css`
  /* font-family: ProximaNova; */
  flex-direction: column;
  flex: 1;
  background-color: ${themeConfig.color.dark.jupiter};
  position: fixed;
  left: -400px;
  width: 400px;
  top: 0px;
  bottom: 0px;
  display: flex;
  will-change: left, margin;
  transition: left 0.4s ease, margin 0.4s ease;
  z-index: 21;

  @media (max-width: 767px) {
    width: 100%;
    left: -100%;
  }

  &.open {
    left: 0;
  }

  &.live-class {
    position: absolute;
  }
`;

export const courseText = css`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media all and (max-width: 767px) {
    width: 253px;
  }
`;

export const backContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  @media all and (max-width: 767px) {
    display: none;
  }
`;

export const backButton = css`
  font-size: 14px !important;
  letter-spacing: -0.1px !important;

  svg {
    margin-right: 6px;
    height: 10px;
    width: 5px;
  }
`;

export const teachButton = css`
  svg {
    margin-right: 6px;
    height: 14px;
    width: 14px;
  }
`;

export const courseName = css`
  color: ${themeConfig.color.dark.silver};
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  white-space: normal;
`;

export const progressBarFill = percent => css`
  border-radius: 2px;
  height: 2px;
  background-color: ${themeConfig.color.dark.sapphire};
  position: relative;
  width: 100%;
  right: ${100 - percent}%;
`;

export const mobileTeachBtn = css`
  position: absolute;
  right: -27px;
  bottom: -2px;
`;

const kBoldFont = 500.0;
export const styles = {
  classBased: {
    '.CircularProgressbarSVG': {
      display: 'block',
      height: '16px',
      width: '16px',
      marginRight: '0px',
      transition: 'height 0.2s ease, width 0.2s ease'
    },
    '.inProgressIconWrapper .CircularProgressbarSVG .CircularProgressbar-trail': {
      stroke: themeConfig.color.dark.uranus
    },
    '.CircularProgressbarSVG .CircularProgressbar-trail': { stroke: themeConfig.color.dark.venus },
    '.CircularProgressbarSVG .CircularProgressbar-text': { display: 'none' },
    '.CircularProgressbarSVG .CircularProgressbar-path': {
      stroke: themeConfig.color.dark.topaz,
      strokeLinecap: 'round',
      transition: 'stroke-dashoffset 0.5s ease 0s'
    },
    '.CircularProgressbarSVG.isInSync .CircularProgressbar-path': {
      stroke: themeConfig.color.dark.ruby
    },
    '.sectionInfoContainer': {
      height: '64px',
      padding: '14px 12px 14px 20px',
      cursor: 'pointer',
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      background: themeConfig.color.dark.jupiter
    },
    '.sectionInfoContainer .sectionLabel': {
      color: themeConfig.color.dark.silver,
      fontSize: '14px',
      lineHeight: '1.71',
      flexDirection: 'row',
      fontWeight: '500',
      letterSpacing: 'normal',
      fontStretch: 'normal',
      display: 'flex'
    },
    '.sectionInfoContainer.active .sectionLabel': {
      fontWeight: '500',
      color: themeConfig.color.dark.silver
    },
    '.sectionIconContainer': {
      marginRight: '13px'
    },
    '.sectionCardsContainer': {
      backgroundColor: themeConfig.color.dark.mars
    },
    '.cardCellContainer .cardInfoContainer': {
      display: 'flex',
      padding: '13px 19px 13px 20px',
      flexDirection: 'row',
      float: 'left',
      alignItems: 'center',
      margin: '0',
      color: themeConfig.color.dark.iron,
      minHeight: '45px'
    },
    '.cardCellContainer .cardInfoContainer.active, .cardCellContainer .cardInfoContainer.tempActive': {
      backgroundColor: themeConfig.color.dark.venus,
      color: themeConfig.color.dark.white
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible):hover': {
      color: themeConfig.color.dark.white
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible):hover .cardIcon': {
      fill: themeConfig.color.dark.iron
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible).active, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).tempActive, .cardCellContainer .cardInfoContainer:not(.isNotAccessible):active': {
      color: themeConfig.color.dark.white
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible).active .cardName, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).active .timeLabel': {
      color: themeConfig.color.dark.white,
      fill: themeConfig.color.dark.white
    },
    '.cardCellContainer .cardInfoContainer .cardName, .cardCellContainer .cardInfoContainer .timeLabel': {
      color: themeConfig.color.dark.iron,
      fill: themeConfig.color.dark.iron
    },
    '.cardCellContainer .cardInfoContainer:not(.isNotAccessible):active .cardIcon, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).active  .cardIcon, .cardCellContainer .cardInfoContainer:not(.isNotAccessible).tempActive .cardIcon': {
      fill: themeConfig.color.dark.iron
    },
    '.cardStatusIcon': {
      height: '16px',
      width: '16px',
      marginRight: '0px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'height 0.2s ease, width 0.2s ease, margin 0.2s ease'
    },
    '.inProgressIconWrapper': {
      position: 'relative',
      transition: 'margin 0.2s ease, height 0.2s ease, width 0.2s ease',
      height: '16px',
      width: '16px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '.inProgressIconContainer': {
      position: 'absolute',
      top: '25%',
      left: '22%'
    },
    '.inProgressIconContainer.active': {
      marginRight: ''
    },
    '.sideViewBlocker': {
      position: 'fixed',
      top: '-100px',
      left: '-100px',
      opacity: '0.0001',
      background: 'rgba(0,0,0,0.3)',
      transition: 'opacity 0.4s'
    },
    '.sideViewBlocker.show': {
      top: '0px',
      bottom: '0px',
      right: '0px',
      left: '0px',
      opacity: '1',
      zIndex: '20'
    },
    '.sideViewBlocker.disabled': {
      cursor: 'not-allowed'
    },
    '.viewCertificateIcon': {
      position: 'absolute',
      right: '-23px',
      top: '0px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '25px',
      height: '25px',
      borderRadius: '50px',
      cursor: 'auto',
      backgroundColor: '#38485e'
    },
    '.viewCertificateIcon svg': {
      fill: '#ffffff'
    }
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: 4,
    position: 'relative'
  },
  open: {
    marginLeft: '400px'
  },
  sideWrapper: {
    position: 'relative',
    width: '100%'
  },
  liveClassSideWrapper: {
    position: 'absolute',
    top: '0px',
    background: 'white',
    width: '100%'
  },
  progressAndEnrollWrapper: {
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  progressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '252px',
    position: 'relative'
  },
  progressContainer: {
    width: '100%',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    height: '25px'
  },
  progressBar: {
    backgroundColor: themeConfig.color.dark.venus,
    width: '100%',
    border: 'none',
    height: '2px',
    borderRadius: '2px',
    overflow: 'hidden',
    position: 'relative',
    WebkitMaskImage:
      'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC)'
  },
  progressText: {
    color: themeConfig.color.dark.iron,
    fontSize: '14px',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    fontWeight: '500',
    fontStretch: 'normal'
  },
  text: {
    fontSize: '12px',
    color: 'rgba(0,0,0,0.8)',
    marginLeft: '2px',
    float: 'left',
    fontWeight: '400'
  },
  content: {
    overflowY: 'auto',
    flexDirection: 'column',
    position: 'absolute',
    bottom: '0px',
    width: '400px',
    boxSizing: 'border-box'
  },
  contentTopSpacing: {
    top: '210px'
  },
  contentSection: {
    color: themeConfig.color.dark.venus,
    padding: '25px 20px 12px',
    lineHeight: '18px',
    fontWeight: kBoldFont,
    fontSize: '13px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    borderBottom: '1px solid #303d4a'
  },
  width100: {
    width: '100%'
  },
  backToSection: {
    padding: '20px 20px 19px',
    borderBottom: `1px solid ${themeConfig.color.dark.venus}`,
    letterSpacing: '-0.1px',
    fontSize: '14px',
    color: '#fff',
    lineHeight: '22px',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative'
  },
  container: {
    flexShrink: 0
  },
  enrollDialogStyle: {
    width: 300,
    height: 200
  },
  icon: {
    float: 'left',
    marginRight: 5
  },
  border: {
    width: '100%',
    bottom: 0,
    borderBottom: 'solid 2px #182d3c'
  },
  backIconContainer: {
    minWidth: '8px',
    width: '8px',
    marginRight: '7px',
    display: 'flex'
  },
  cardLink: {
    color: '#4a90e2',
    letterSpacing: '0.2px',
    lineHeight: '25px',
    fontSize: '15px',
    fontWeight: '500',
    cursor: 'pointer',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  mobileCloseBtnContainer: {
    position: 'absolute',
    top: '16px',
    right: '15px',
    padding: '5px',
    cursor: 'pointer'
  },
  iconStyle: {
    marginRight: '6px',
    height: '16',
    width: '16',
    fill: 'currentColor'
  }
};
